import Icon from '../components/Icon.vue'

Icon.register({
  'pencil-ruler': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M109.5 244l-100.2-100.2c-12.4-12.4-12.4-32.5 0-44.9l89.7-89.7c12.4-12.4 32.5-12.4 44.9 0l33.6 33.7-61.7 61.7c-3.1 3.1-3.1 8.1 0 11.2l11.2 11.2c1.3 1.3 3.8 2.3 5.6 2.3 1.8 0 4.3-1 5.6-2.3l61.7-61.7 44.1 44.1zM497.9 127.2l-46 46-113.2-113.2 46-46c18.8-18.8 49.2-18.8 67.9 0l45.3 45.3c18.8 18.8 18.8 49.2 0 67.9zM316.1 82.7l113.2 113.2-296.9 296.9-107.5 18.8c-14.5 2.5-27.1-10.1-24.6-24.6l18.8-107.4zM502.7 368.1c12.4 12.4 12.4 32.5 0 44.9l-89.7 89.7c-12.4 12.4-32.5 12.4-44.9 0l-100.2-100.2 134.6-134.6 44.1 44.1-61.7 61.7c-3.1 3.1-3.1 8.1 0 11.2l11.2 11.2c3.1 3.1 8.1 3.1 11.2 0l61.7-61.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/pencil-ruler.js
// module id = 1626
// module chunks = 0